<div class="modal fade" id="dlgFrancionadoForm" tabindex="-1" role="dialog" aria-labelledby="Anular"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form [formGroup]="entidadeForm" autocomplete="off" class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Fracionamento</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0 overflow-auto" style="height: 400px;">
        <div class="row m-0">
          <div class="col-sm-12">
            <p-fieldset legend="Produto a ser fracionado">
              <div class="form-row" formGroupName="dissolver">
                <div class="col-sm-9 form-group">
                  <label for="dissolver_prod">Produto</label>
                  <p-autoComplete id="dissolvido_prod" formControlName="produto" [forceSelection]="true"
                    [autoHighlight]="true" [field]="dissolverAutoComplete.conversor"
                    (onSelect)="carregarUnidades($event, 'F1')" [suggestions]="dissolverAutoComplete.lista"
                    (completeMethod)="dissolverAutoComplete.filtrar($event)" [style]="{ width: '100%' }"
                    inputStyleClass="form-control" minLength="2">
                    <ng-template let-produto pTemplate="item">
                      {{produto.codigo}} {{produto.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
                <div class="col-sm-3 form-group">
                  <label for="dissolver_un">UN.</label>
                  <select [compareWith]="compareFn" id="dissolver_un" formControlName="unidade" class="form-control"
                    style="width: 100%;" (change)="changeUnidade('F1')">
                    <option [ngValue]="item.unidade" *ngFor="let item of listProdUnDissolver">
                      {{item.unidade.nome}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-9 form-group">
                  <label for="setor_almoxarifado">Setor</label>
                  <select [compareWith]="compareFn" id="setor_almoxarifado" formControlName="setor_almoxarifado"
                    class="form-control font-weight-bold">
                    <option [ngValue]="item" *ngFor="let item of listSetores">
                      {{item.setor.nome}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-3 form-group">
                  <label for="dissolver_qtde">Qtde.</label>
                  <input id="dissolver_qtde" [imask]="imaskValor" unmask="typed" class="form-control" type="text"
                    formControlName="qtd_dissolver">
                </div>
              </div>
            </p-fieldset>
          </div>
        </div>
        <div class="row m-0">
          <div class="col-sm-12">
            <p-fieldset legend="Produto fracionado">
              <div class="form-row" formGroupName="dissolvido">
                <div class="col-sm-9 form-group">
                  <label for="dissolvido_prod">Produto</label>
                  <p-autoComplete id="dissolvido_prod" formControlName="produto" [forceSelection]="true"
                    [autoHighlight]="true" [field]="dissolvidoAutoComplete.conversor"
                    (onSelect)="carregarUnidades($event, 'F2')" [suggestions]="dissolvidoAutoComplete.lista"
                    (completeMethod)="dissolvidoAutoComplete.filtrar($event)" [style]="{ width: '100%' }"
                    inputStyleClass="form-control" minLength="2">
                    <ng-template let-produto pTemplate="item">
                      {{produto.codigo}} {{produto.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
                <div class="col-sm-3 form-group">
                  <label for="dissolvido_un">UN.</label>
                  <select [compareWith]="compareFn" id="dissolvido_un" formControlName="unidade" class="form-control"
                    style="width: 100%;" (change)="changeUnidade('F2')">
                    <option [ngValue]="item.unidade" *ngFor="let item of listProdUnDissolvido">
                      {{item.unidade.nome}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-9 form-group">
                  <label for="favorecido">Fornecedor</label>
                  <p-autoComplete formControlName="favorecido" [field]="favorecidoAutoComplete.conversor"
                    [suggestions]="favorecidoAutoComplete.lista"
                    (completeMethod)="favorecidoAutoComplete.filtrar($event)" inputStyleClass="form-control"
                    minLength="2" [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true"
                    *ngIf="favorecidoAutoComplete">
                    <ng-template let-favorecido pTemplate="item">
                      {{favorecido.cpf_cnpj | CPF}} {{favorecido.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
                <div class="col-sm-3 form-group">
                  <label for="dissolvido_qtde">Qtde.</label>
                  <input id="dissolvido_qtde" [imask]="imaskValor" unmask="typed" class="form-control" type="text"
                    formControlName="qtd_dissolvido">
                </div>
              </div>
            </p-fieldset>
          </div>
        </div>
        <hr class="ml-2 mr-2"/>
        <div class="row m-0">
          <div class="col-sm-12 form-group">
            <label for="observacao">Observação</label>
            <textarea name="obs" id="observacao" rows="3" class="form-control" formControlName="observacao">
            </textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button (click)="submitForm()" type="submit" class="btn btn-danger btn-sm float-right ml-2">Fracionar</button>
        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
      </div>
    </form>
  </div>
</div>